// import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useWindowSize from '../hooks/useWindowSize';

const MobileBottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { isMobile } = useWindowSize();

  // Solo mostrar en móvil
  if (!isMobile) return null;

  // No mostrar en rutas de admin
  if (location.pathname.startsWith('/admin')) return null;

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e1e5e9',
    padding: '8px 0 12px 0',
    zIndex: 1000,
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
  };

  const navListStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: 0,
    padding: '0 16px',
    listStyle: 'none',
  };

  const navItemStyle = (active = false) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 8px',
    borderRadius: '8px',
    textDecoration: 'none',
    color: active ? '#4352A9' : '#6c757d',
    fontSize: '11px',
    fontWeight: active ? '600' : '500',
    transition: 'all 0.3s ease',
    minWidth: '50px',
    backgroundColor: active ? 'rgba(67, 82, 169, 0.1)' : 'transparent',
  });

  const iconStyle = (active = false) => ({
    fontSize: '20px',
    color: active ? '#4352A9' : '#6c757d',
  });

  // Navegación para usuarios autenticados
  const authenticatedNavItems = [
    {
      path: '/',
      icon: 'home',
      label: 'Inicio',
    },
    {
      path: '/tutor',
      icon: 'dashboard',
      label: 'Dashboard',
    },
    {
      path: '/tutor/futbolistas',
      icon: 'sports_soccer',
      label: 'Futbolistas',
    },
    {
      path: '/products',
      icon: 'shopping_cart',
      label: 'Tienda',
    },
    {
      path: '/direct-profile',
      icon: 'person',
      label: 'Perfil',
    },
  ];

  // Navegación para usuarios no autenticados
  const publicNavItems = [
    {
      path: '/',
      icon: 'home',
      label: 'Inicio',
    },
    {
      path: '/liga-prokids',
      icon: 'sports_soccer',
      label: 'Liga',
    },
    {
      path: '/summer-edition',
      icon: 'wb_sunny',
      label: 'Summer',
    },
    {
      path: '/products',
      icon: 'shopping_cart',
      label: 'Tienda',
    },
    {
      path: '/login',
      icon: 'login',
      label: 'Login',
    },
  ];

  const navItems = user ? authenticatedNavItems : publicNavItems;

  return (
    <nav style={navStyle}>
      <ul style={navListStyle}>
        {navItems.map((item, index) => {
          const active = isActive(item.path);
          
          return (
            <li key={index}>
              <Link
                to={item.path}
                style={navItemStyle(active)}
                onTouchStart={(e) => {
                  // Feedback táctil en móvil
                  e.target.style.transform = 'scale(0.95)';
                }}
                onTouchEnd={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <span className="material-icons" style={iconStyle(active)}>
                  {item.icon}
                </span>
                <span>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
